import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material';
import { NgbModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { EstablecimientoSearchComponent } from './esteblecimiento-search/establecimiento-search.component';
import { FiltersComponent } from './filters/filters.component';
import { FormularioGenericComponent } from './formulario-generic/formulario-generic.component';
import { InformacionPacienteComponent } from './formulario-generic/informacion-paciente/informacion-paciente.component';
import { SeguimientoSolicitudComponent } from './formulario-generic/seguimiento-solicitud/seguimiento-solicitud.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { ControlPreguntasService } from './services/ControlPreguntasService';
import { EstablecimientosComponent } from './establecimientos/establecimientos.component';
import { ButtonViewComponent } from './buttonViewComponent';
import { ProfileComponent } from './profile/profile.component';
import { CedulaPipe } from './cedula.pipe';

@NgModule({
	imports: [
		FormsModule,
		ReactiveFormsModule,
		CommonModule,
		MatPaginatorModule,
		NgbModule.forRoot(),
		NgbTypeaheadModule.forRoot()
	],
	declarations: [
		EstablecimientoSearchComponent,
		FormularioGenericComponent,
		FiltersComponent,
		EstablecimientosComponent,
		PaginatorComponent,
		InformacionPacienteComponent,
		SeguimientoSolicitudComponent,
		DatePickerComponent,
		ButtonViewComponent,
		ProfileComponent,
		CedulaPipe
	],
	entryComponents: [ButtonViewComponent],
	exports: [
		EstablecimientoSearchComponent,
		FormularioGenericComponent,
		FiltersComponent,
		EstablecimientosComponent,
		PaginatorComponent,
		InformacionPacienteComponent,
		SeguimientoSolicitudComponent,
		DatePickerComponent,
		ButtonViewComponent,
		ProfileComponent,
		CedulaPipe
	],
	providers: [ControlPreguntasService]
})
export class SharedModule { }
